import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import Header from "../Header"; 
import Sidebar from "../Sidebar"; 

const FamilyHistory = () => {
    const navigate = useNavigate(); // Initialize navigation hook
    const [activeTab, setActiveTab] = useState("Family History"); // Default active tab

    // Handle Sidebar Clicks (Redirect to Home when "Profile" is clicked)
    const handleTabChange = (item) => {
        if (item === "Profile") {
            navigate("/home"); // Navigate to Home Page
        } else {
            setActiveTab(item); // Change active tab normally
        }
    };

    return (
        <div className="flex flex-col h-screen">
            {/* Header */}
            <div className="fixed top-0 left-0 w-full z-50 bg-primary">
                <Header />
            </div>

            {/* Main Layout */}
            <div className="flex flex-1 mt-[72px]">
                {/* Sidebar (Hidden on md and smaller) */}
                <div className="w-64 bg-white shadow-md h-[calc(100vh-72px)] overflow-y-auto hidden lg:block">
                    <Sidebar
                        sections={[
                            { title: "About Me", items: ["Profile", "Family History"] },
                            { title: "Application & Enrollment", items: ["Enrollment Status", "Programs"] },
                            { title: "Concierge", items: ["My Messages", "Send us a Message"] },
                        ]}
                        activeTab={activeTab} 
                        setActiveTab={handleTabChange} // Now handles navigation
                    />
                </div>

                {/* Main Content */}
                <main className="flex-1 p-6 bg-gray-100 overflow-y-auto mt-[40px]">
                    <h1 className="text-2xl font-bold">{activeTab} Page</h1>
                    <p className="mt-4 text-gray-700">This is the {activeTab} content.</p>
                </main>
            </div>
        </div>
    );
};

export default FamilyHistory;
